import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import classes from './PostPickup.module.scss';

interface Post {
  id: number;
  title: { rendered: string };
  featured_media_url?: string;
}

// カテゴリの最新記事をカードで表示する TOP 用ピックアップ
const PostPickup: React.FC<{ categoryId: number; limit?: number }> = ({ categoryId, limit = 3 }) => {
  const [posts, setPosts] = useState<Post[]>([]);
  const location = useLocation();
  const langCode = location.pathname.split('/')[1] || 'ja';

  const stripHtml = (html: string) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  useEffect(() => {
    // カテゴリ記事は日本語版のみのため常に日本語 API を使用（PostList と同じ方針）
    const baseUrl = 'https://hado-official.com/wp-json/wp/v2';
    const url = `${baseUrl}/posts?_embed&categories=${categoryId}&per_page=${limit + 5}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const filtered = data.filter((post: any) => {
          const postLink = post.link || '';
          return !postLink.includes('/en/') && !postLink.includes('/zh/');
        });
        setPosts(filtered.slice(0, limit).map((post: any) => ({
          ...post,
          featured_media_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url,
        })));
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [categoryId, limit]);

  return (
    <ul className={classes.pickupList}>
      {posts.map((post) => (
        <li key={post.id} className={classes.pickupItem}>
          <Link to={`/${langCode}/post/${post.id}`}>
            {post.featured_media_url && <img src={post.featured_media_url} alt="" className={classes.pickupItemImg} />}
            <div className={classes.pickupItemTitle}>{stripHtml(post.title.rendered)}</div>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default PostPickup;
